<template>
	<div>
		<main style='background: #EEEEEE;height: 730px;'>
			<img src="../../assets/images/banner_bg.jpg" alt="" class="topImg">
			<div class="centerBox">
				<div class="liucheng">
					<div>
						<p class="title">鉴定申请注册</p>
						<div class="boxItems">

							<div class="boxItem">
								<p>用户名：</p>
								<el-input placeholder="4-20个字母或数字组合" v-model="username" clearable>
								</el-input>
							</div>
							<div class="boxItem">
								<p>密码：</p>
								<el-input v-model="password" placeholder="6-20个字母或数字组合" show-password clearable>
								</el-input>
							</div>
							<div class="boxItem">
								<p>手机号：</p>
								<el-input v-model.number="tel" type='number' placeholder="请输入相应内容"></el-input>
							</div>
							<p class="btn" @click="register">提交</p>
							<el-checkbox v-model="checked" style="margin-top: 45px;
    margin-left: 80px;">我已阅读并同意 <span style="color: #0065dc;" @click="xy">《河北省司法鉴定协会网注册协议》</span></el-checkbox>
						</div>
					</div>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
	import navheader from '../../components/navheader.vue'
	import footeritem from '../../components/footeritem.vue'
	import axios from 'axios'
	import '../../assets/css/index.less'
	import '../../assets/css/fuWu.less';
	export default {
		name: 'Pdf',
		components: {
			navheader,
			footeritem
		},
		data() {
			return {
				username: '',
				password: '',
				tel: '',
				value: '',
				checked: false
			};
		},
		methods: {
			// 司法鉴定人列表
			xy() {
				var that = this
				var params = new URLSearchParams();
				axios.get('/system/notice/189').then(res => {
				 if (res.data.code == 200) {
					 this.$router.push('/newsDetails')
				 }
				}, err => {})
			},
			// 司法鉴定人列表
			register() {
				var that = this
				var telRex = /^1(3|4|5|6|7|8|9)\d{9}$/;
				if (!that.checked) {
					this.$message({
						message: '请先勾选协议',
						type: 'warning'
					});
					return false;
				} else if (that.username == '') {
					this.$message({
						message: '用户名不能为空',
						type: 'warning'
					});
					return false;
				} else if (that.password == '') {
					this.$message({
						message: '密码不能为空',
						type: 'warning'
					});
					return false;
				} else if (that.tel == '') {
					this.$message({
						message: '手机号不能为空',
						type: 'warning'
					});
					return false;
				} else if (!telRex.test(that.tel)) {
					this.$message({
						message: '输入的手机号有误',
						type: 'warning'
					});
					return false;
				}
				var params = new URLSearchParams();
				// params.append('username', that.username)
				// params.append('password', that.password)
				// params.append('phone', that.tel)
				axios.post('/system/customer/register', {'username':that.username,'password':that.password,'phone':that.tel},{headers:{'Content-Type':'application/json;charset=UTF-8'}}).then(res => {
					if (res.data.code == 200) {
						this.$message({
							message: '注册成功',
							type: 'success'
						});

						this.$router.push('/jdapply')
						// this.personBox = res.data.rows.slice(0,6)
					}
				}, err => {})
			}
		},
		created() {

		},
		mounted() {
			let that = this;
		},
	};
</script>

<style lang="less" scoped="scoped">
	.topImg {
		width: 100%;
		display: block;
	}

	.centerBox {
		width: 1134px;
		margin: 0 auto;
		overflow: hidden;
		box-sizing: border-box;
	}

	.titleTip {
		width: 100%;
		border-left: 4px solid #01458E;
		padding-left: 10px;
	}

	.liucheng {
		position: absolute;
		top: 300px;
		left: 50%;
		margin-left: -500px;

		// background: #F8F8F8;
		// padding: 30px 0;
		&>div {
			width: 1000px;
			height: 500px;
			margin: 0 auto;
			box-shadow: 0px 0px 0px NaNpx rgba(4, 32, 89, 0.15);
			box-sizing: border-box;
			border-radius: 10px;
			background: #fff;
			overflow: hidden;

			.title {
				width: 100%;
				height: 67px;
				line-height: 67px;
				background: #0068d8;
				padding: 0 30px;
				box-sizing: border-box;
				font-size: 22px;
				font-family: Microsoft YaHei, Microsoft YaHei-Bold;
				font-weight: 700;
				text-align: left;
				color: #ffffff;
				letter-spacing: 1px;
			}

			.boxItems {
				width: 100%;
				padding: 50px 230px;
				box-sizing: border-box;
				overflow: hidden;

				.boxItem {
					width: 100%;
					margin-bottom: 15px;
					overflow: hidden;
					display: flex;
					align-items: center;

					p {
						width: calc(20% - 15px);
						font-size: 16px;
						text-align: right;
						font-family: Microsoft YaHei, Microsoft YaHei-Regular;
						font-weight: 400;
						color: #666666;
					}

					.el-select,
					.el-input,
					.el-textarea {
						width: 420px;
						margin-left: 15px;
					}
				}

				.btn {
					width: 200px;
					height: 61px;
					line-height: 61px;
					background: #0068d8;
					border-radius: 15px;
					box-shadow: 0px 0px 0px NaNpx rgba(4, 32, 89, 0.15);
					font-size: 18px;
					font-family: Microsoft YaHei, Microsoft YaHei-Bold;
					font-weight: 700;
					text-align: left;
					color: #ffffff;
					margin: 0 auto;
					margin-top: 30px;
					text-align: center;
					cursor: pointer;
				}
			}

		}

		@media screen and (max-width: 1024px) {
			&>div {
				width: 90%;
			}
		}
	}
</style>
